import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import PubSub from 'pubsub-js';

import './Live.css';
import Lane from '../components/Lane';
import IconButton from '../components/IconButton';
import { myoService } from '../services/MyoService';
import { storageService } from '../services/StorageService'; 
import colors from '../colors';
import topics from '../topics';

class Live extends Component {
  constructor(props) {
    super(props);
    
    let ids = storageService.get(storageService.stores.devices);
    let myos = myoService.getMyos(true).filter((myo) => {
      return ids.includes(myo.macAddress);
    });

    this.state = {
      ids: ids,
      myos: myos,
      paused: true
    };

    this.renderPlayback = this.renderPlayback.bind(this);
    this._handlePlay = this._handlePlay.bind(this);
    this._handlePause = this._handlePause.bind(this);
    this._handleMyoChanged = this._handleMyoChanged.bind(this);
    this._handleKeypress = this._handleKeypress.bind(this);
  }

  componentDidMount() {
    PubSub.subscribe(myoService.topics.connected, this._handleMyoChanged);
    PubSub.subscribe(myoService.topics.disconnected, this._handleMyoChanged);
    PubSub.subscribe(topics.keyPress, this._handleKeypress);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(myoService.topics.connected, this._handleMyoChanged);
    PubSub.unsubscribe(myoService.topics.disconnected, this._handleMyoChanged);
    PubSub.unsubscribe(topics.keyPress, this._handleKeypress);

    if (!this.state.paused) {
      for (let i = 0; i < this.state.myos.length; i++) {
        this.state.myos[i].streamEMG(false);
      }
    }
  }

  render() {
    let { myos } = this.state;
    let style = this._getDefaultStyles();
    let navIconStyle = { width: 64, height: 64 };

    return (
      <div className="live page" style={style}>
        <div className="content">
          <div className="heading">
            <h1>live session</h1>
          </div>
          <div className="display flex-fill flex-row">
            { myos.map((myo) => {
              return <Lane key={myo.macAddress} device={myo} />
            })}
          </div>
          <div className="navLeft flex-column flex-justify-items">
            <IconButton icon="chevron-left" iconStyle={navIconStyle}
                        onClick={this._handleNavBack}  />
          </div>
          <div className="navBottom flex-row flex-justify-items">
            { this.renderPlayback() }
          </div>
        </div>
      </div>
    );
  }

  renderPlayback() {
    let navIconStyle = { width: 64, height: 64 };

    if (this.state.paused) {
      return (
        <IconButton icon="play" iconStyle={navIconStyle}
                    onClick={this._handlePlay} />
      );
    }
    else {
      return (
        <IconButton icon="pause" iconStyle={navIconStyle}
                    onClick={this._handlePause} />
      );
    }
  }

  _getDefaultStyles() {
    let defaultStyle = {
      backgroundColor: colors.white,
    };

    return defaultStyle;
  }

  _handleMyoStream(stream) {
    for (let i = 0; i < this.state.myos.length; i++) {
      this.state.myos[i].streamEMG(stream);
    }
    this.setState({ paused: !stream });
  }

  _handlePlay() {
    this._handleMyoStream(true);
  }

  _handlePause() {
    this._handleMyoStream(false);
  }

  _handleMyoChanged() {
    let ids = storageService.get(storageService.stores.devices);
    let myos = myoService.getMyos(true).filter((myo) => {
      return ids.includes(myo.macAddress);
    });

    // BE CAREFUL
    // This is a measure to attempt to re-stream disconnected myo
    // This was not tested properly
    // this.setState({
    //   myos: myos
    // }, function() {
    //   this._handleMyoStream(!this.state.paused);
    // });
  }

  _handleKeypress(topic, key) {
    if (key === 32) {
      if (this.state.paused) {
        this._handlePlay();
      }
      else {
        this._handlePause();
      }
    }
  }

  _handleNavBack() {
    browserHistory.push('/setup');
  }

  _handleNavNext() {
    browserHistory.push('/video');
  }
}

export default Live;



/** WEBPACK FOOTER **
 ** ./src/containers/Live.js
 **/